import { type MessageDescriptor } from 'react-intl';

import { defineContent, type DefinedContent } from '@post-office/define-content';

type MessageKey =
	| 'title'
	| 'description'
	| 'bookNow'
	| 'whyAmISeeingThisIntro'
	| 'whyAmISeeingThisBasedOn'
	| 'reasonRecentPurchase'
	| 'reasonUserCount';

export const registeredContent: DefinedContent<
	[
		'title',
		'description',
		'bookNow',
		'whyAmISeeingThisIntro',
		'whyAmISeeingThisBasedOn',
		'reasonRecentPurchase',
		'reasonUserCount',
	]
> = defineContent({
	default: {
		title: {
			id: 'servco-recent-purchase-in-product-recruitment.message.title',
			defaultMessage: 'Get expert help setting up Service Collection',
			description:
				'Heading of the side nav banner inviting the admin to book a setup session with an Atlassian expert',
			role: 'title',
		},
		description: {
			id: 'servco-recent-purchase-in-product-recruitment.message.description',
			defaultMessage:
				"Discover the best features and configure it to your team's needs.{br}Book a free 45 minute session with an Atlassian expert.",
			description:
				'Body of the side nav banner explaining what the expert session covers. {br} is a line break between the two sentences.',
			role: 'description',
		},
		bookNow: {
			id: 'servco-recent-purchase-in-product-recruitment.message.link.book.now',
			defaultMessage: 'Book now',
			description: 'Call-to-action link that opens the booking page for the expert session',
		},
		whyAmISeeingThisIntro: {
			id: 'servco-recent-purchase-in-product-recruitment.modal.why-am-i-seeing-this.intro',
			defaultMessage:
				'Your organization recently purchased Service Collection. We believe that speaking with an Atlassian expert will help you get the most out of it.',
			description:
				'Opening paragraph of the modal explaining why the admin is being shown the expert session banner',
		},
		whyAmISeeingThisBasedOn: {
			id: 'servco-recent-purchase-in-product-recruitment.modal.why-am-i-seeing-this.based-on',
			defaultMessage: 'This recommendation is based on:',
			description: 'Lead-in sentence before the list of reasons the banner was shown',
		},
		reasonRecentPurchase: {
			id: 'servco-recent-purchase-in-product-recruitment.modal.reason.recent-purchase',
			defaultMessage: 'Your recent purchase of Service Collection',
			description:
				'Reason explaining that the banner is based on a recent Service Collection purchase',
		},
		reasonUserCount: {
			id: 'servco-recent-purchase-in-product-recruitment.modal.reason.user-count',
			defaultMessage: 'The number of users in Service Collection',
			description:
				'Reason explaining that the banner is based on how many users the site has in Service Collection',
		},
	},
});

export const messages: Record<MessageKey, MessageDescriptor> = registeredContent.default;
